// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get FeedbackLookupOptions () {
        return FeedbackLookupOptions;
    },
    get FeedbackModel () {
        return FeedbackModel;
    },
    get FeedbackQueryModel () {
        return FeedbackQueryModel;
    },
    get FeedbackRequestModel () {
        return FeedbackRequestModel;
    },
    get FeedbackRequestResponseQueryModel () {
        return FeedbackRequestResponseQueryModel;
    },
    get FeedbackRequestStatus () {
        return FeedbackRequestStatus;
    },
    get FeedbackSearchServiceModel () {
        return FeedbackSearchServiceModel;
    },
    get FeedbackSharedWithModel () {
        return FeedbackSharedWithModel;
    },
    get FeedbackSortOrderQueryModel () {
        return FeedbackSortOrderQueryModel;
    },
    get FeedbackViewQueryModel () {
        return FeedbackViewQueryModel;
    },
    get FeedbackWithLookupModel () {
        return FeedbackWithLookupModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const FeedbackSharedWithModel = _zod.z.enum([
    "everyone",
    "subject-manager",
    "subject",
    "subject-+-manager",
    "me"
]);
const FeedbackRequestStatus = _zod.z.enum([
    "open",
    "dismissed",
    "completed"
]);
const FeedbackRequestResponseQueryModel = _zod.z.enum([
    "yes",
    "no",
    "any",
    "not-selected"
]);
const FeedbackViewQueryModel = _zod.z.enum([
    "received",
    "given",
    "team",
    "notes",
    "requests",
    "outgoing"
]);
const FeedbackSortOrderQueryModel = _zod.z.enum([
    "asc",
    "desc"
]);
const FeedbackModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    subject_ids: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    author_id: _zod.z.instanceof(_bson.ObjectId),
    categories: _zod.z.array(_zod.z.string()),
    shared_with: FeedbackSharedWithModel,
    last_updated: _zod.z.date(),
    content: _zod.z.string(),
    deleted: _zod.z.boolean(),
    feedback_message: _zod.z.string(),
    task_id: _zod.z.instanceof(_bson.ObjectId).nullish(),
    bulk_notified_at: _zod.z.date().nullish(),
    slack_notified_at: _zod.z.date().nullish(),
    teams_notified_at: _zod.z.date().nullish()
});
const FeedbackSearchServiceModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    subject: _zod.z.array(_zod.z.object({
        name: _zod.z.string(),
        _id: _zod.z.string()
    })),
    author: _zod.z.array(_zod.z.object({
        name: _zod.z.string(),
        _id: _zod.z.string()
    })),
    categories: _zod.z.array(_zod.z.string()),
    shared_with: FeedbackSharedWithModel,
    last_updated: _zod.z.date(),
    content: _zod.z.string(),
    request_message: _zod.z.string(),
    response_to_request: _zod.z.boolean().optional()
});
const FeedbackRequestModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    deleted_at: _zod.z.date().nullish(),
    message: _zod.z.string(),
    requested_by: _zod.z.instanceof(_bson.ObjectId),
    requested_to: _zod.z.instanceof(_bson.ObjectId),
    resulting_feedback: _zod.z.instanceof(_bson.ObjectId).optional(),
    status: FeedbackRequestStatus,
    updated_at: _zod.z.date().optional(),
    task_id: _zod.z.instanceof(_bson.ObjectId).nullish(),
    bulk_notified_at: _zod.z.date().nullish()
});
const FeedbackLookupOptions = _zod.z.object({
    author_name: _zod.z.string(),
    subject_names: _zod.z.array(_zod.z.string()),
    feedback_request_id: _zod.z.instanceof(_bson.ObjectId).optional()
});
const FeedbackWithLookupModel = FeedbackModel.extend({
    ...FeedbackLookupOptions.shape
});
const FeedbackQueryModel = _zod.z.object({
    // Base Fields
    companyId: _zod.z.string(),
    userId: _zod.z.string(),
    subjectId: _zod.z.string().optional(),
    // Permission Flags
    // These are used primarily for the "My Feedback" views to determine what feedback the user can see.
    isUserAdmin: _zod.z.boolean().optional(),
    isUserManagerOfFeedbackSubject: _zod.z.boolean().optional(),
    isUserDownloadingOwnFeedback: _zod.z.boolean().optional(),
    isUserContributorToFeedbackSubject: _zod.z.boolean().optional(),
    // Filters and Sorting
    authorIdFilter: _zod.z.string().optional(),
    subjectIdFilter: _zod.z.string().optional(),
    createdAfterFilter: _zod.z.string().optional(),
    createdBeforeFilter: _zod.z.string().optional(),
    responseToRequestFilter: FeedbackRequestResponseQueryModel.optional(),
    categoriesFilter: _zod.z.array(_zod.z.string()).optional(),
    sharedWithFilter: FeedbackSharedWithModel.optional(),
    feedbackSubjectEmployees: _zod.z.array(_zod.z.string()).optional(),
    sortOrder: FeedbackSortOrderQueryModel.optional()
});
